import React from 'react';
import { LineHaulSortListEntry } from '../../fetch/fetchLineHaulSort';
import Button from '../../components/buttons/Button';

interface Props {
  listEntry: LineHaulSortListEntry;
  markAsPresorted: (senderName: string, orders: string[]) => void;
}

interface PresortCount {
  accountId?: number;
  presortedOrders: string[];
}

export function LinehaulPresortBar({ listEntry, markAsPresorted }: Props) {
  const presortCounts = new Map<string, PresortCount>();
  listEntry.orders.forEach(order => {
    if (
      order.presorted &&
      order.scannedParcelCount < order.preciseParcelCount &&
      order.partnerScanCount > 0
    ) {
      const presortCount = presortCounts.get(order.order.senderName);
      if (presortCount) {
        presortCounts.set(order.order.senderName, {
          accountId: presortCount.accountId,
          presortedOrders: [...presortCount.presortedOrders, order.order.id],
        });
      } else {
        presortCounts.set(order.order.senderName, {
          accountId: order.order.accountId,
          presortedOrders: [order.order.id],
        });
      }
    }
  });

  if (presortCounts.size === 0) {
    return null;
  }

  return (
    <div className="linehaul-sort-list__presort">
      <div className="linehaul-sort-list__presort__title">
        <span>Confirm presorting</span>
      </div>
      <div>
        {Array.from(presortCounts.keys()).map(senderName => (
          <Button
            className="linehaul-sort-list__presort__button"
            key={`presort_${senderName}`}
            title={`${senderName} (${
              presortCounts.get(senderName).presortedOrders.length
            })`}
            type="slim"
            onClick={() =>
              markAsPresorted(
                senderName,
                presortCounts.get(senderName).presortedOrders
              )
            }
          />
        ))}
      </div>
    </div>
  );
}
